module.exports = __webpack_public_path__ + "assets/img/1799413edba475aa203416d85a8d3e80.png";